import { Component } from '@angular/core';

@Component({
    selector: 'app-public',
    templateUrl: './public.layout.html',
    styleUrls: ['./public.layout.scss'],
    standalone: false
})
export class PublicLayoutComponent { }
